export type CreditPackSize = 5 | 10 | 15;

/** Tarifs packs vidéo — montants TTC (€). Source unique front + alignée backend creditPacks.ts */
export const CREDIT_PACK_PRICE_EUR_TTC: Record<CreditPackSize, number> = {
  5: 29,
  10: 49,
  15: 69,
};

export const CREDIT_PACK_OPTIONS: { size: CreditPackSize; priceEur: number; billingMode: `pack_${CreditPackSize}` }[] = [
  { size: 5, priceEur: CREDIT_PACK_PRICE_EUR_TTC[5], billingMode: 'pack_5' },
  { size: 10, priceEur: CREDIT_PACK_PRICE_EUR_TTC[10], billingMode: 'pack_10' },
  { size: 15, priceEur: CREDIT_PACK_PRICE_EUR_TTC[15], billingMode: 'pack_15' },
];

export function formatPackPriceTtc(size: CreditPackSize): string {
  return `${CREDIT_PACK_PRICE_EUR_TTC[size]} € TTC`;
}

/** Plan transmis à l’API paiement (pool unique de crédits vidéo). */
export const CHECKOUT_PACK_PLAN = 'emotion' as const;

export function isPackBillingMode(mode: string): mode is `pack_${CreditPackSize}` {
  return mode === 'pack_5' || mode === 'pack_10' || mode === 'pack_15';
}

export type UserCreditsDto = {
  decouverte: number;
  video: number;
};

export function totalUserCredits(credits: UserCreditsDto): number {
  return credits.decouverte + credits.video;
}
